var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.addItemSubAccountShow,
          expression: "addItemSubAccountShow"
        }
      ],
      staticClass: "popup",
      attrs: { "element-loading-background": "rgba(0, 0, 0, 0.1)" }
    },
    [
      _c(
        "div",
        { staticClass: "content", attrs: { id: "add-item-sub-account" } },
        [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("language.popup.cloudTransferPopup.pleaSelect"))
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closeTreeDialog()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "copyTree",
              staticClass: "task-content",
              style: _vm.flowShow ? "pointer-events: none;" : ""
            },
            [
              _c(
                "el-scrollbar",
                { ref: "subAddItemScroll", staticStyle: { height: "100%" } },
                [
                  _c(
                    "div",
                    { staticClass: "tree-nodes" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isCloudsNull && !_vm.loading,
                              expression: "isCloudsNull&&!loading"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.toAddCloudPage()
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "tree-nocloud" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.sharesPage.mustAddClouds")
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.model, function(item, index) {
                        return _c(
                          "ul",
                          { key: index },
                          [
                            _c("tree", {
                              ref: "tree",
                              refInFor: true,
                              attrs: {
                                model: item,
                                index: index,
                                treeShow: true,
                                transferAimFlag: "addSubItem"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "task-footer",
              style: _vm.flowShow ? "pointer-events: none;" : ""
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.loading,
                      expression: "!loading"
                    },
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingStart,
                      expression: "loadingStart"
                    }
                  ],
                  staticClass: "task-button",
                  style: _vm.flowShow ? "background-color: #dcdfe6;" : "",
                  on: {
                    click: function($event) {
                      return _vm.addItems()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cbedad2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cbedad2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/sub_account_popups/add_item_popup.vue
// module id = null
// module chunks = 